import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapiesPipe',
  pure: false,
})
export class TherapiesPipe implements PipeTransform {
  transform(therapies: any[]): string {
    let therapiesText = '';
    if (therapies) {
      therapies.forEach(item => {
        const therapy = Therapies.therapyItems.find(therapyItem => therapyItem.id === item);
        if (therapy) {
          therapiesText += `${therapy.abbreviation} `;
        }
      });
    }
    return therapiesText;
  }
}
